import { call, put } from "redux-saga/effects";
import { AxiosError, AxiosResponse } from "axios";

// Response / Request
import { Result } from "@models/common/resultResponse";
import { KeyValue } from "@/main/models/common";

// Redux
import { saveSupplierType } from "./index";

// Api's
import { supplierTypeApi } from "../../api";
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from "@/main/services/utils";

export function* getSupplierTypeSaga() {
	try {
		const response: AxiosResponse<Result<KeyValue[]>> = yield call(supplierTypeApi.getDomain);

		if (response.data.result) {
			yield put(saveSupplierType(response.data.result, false, null));
		}
	} catch (exception) {
		if (exception instanceof AxiosError) {
			const resultError = errorBoundaryReduxSaga(exception);
			renderErrorReduxSaga(resultError);

			yield put(saveSupplierType(null, true, resultError.messagesDataError));
		}
	}
}
